import { UPDATE_SERVICE_PRICING_REDUCER } from 'store/actionTypes';
import {
    ActionType,
    ServicePricingModal,
    
} from 'utils/modals';

export const ServicePricingReducer = (
    state: ServicePricingModal = new ServicePricingModal(),
    action: ActionType,
) => {
    switch (action.type) {
        case UPDATE_SERVICE_PRICING_REDUCER:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
